module.exports = __webpack_public_path__ + "img/cart-white.b377fcbf.svg";